import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const empty = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const { t } = useApp();
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) {
      toast.error(t("passwordsDontMatch"));
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success(t("passwordChanged"));
      setForm(empty);
      onOpenChange(false);
    } catch (err) { toast.error(apiError(err)); }
    finally { setSaving(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle className="font-heading">{t("changePassword")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>{t("currentPassword")} *</Label>
            <Input data-testid="current-password-input" required type="password" value={form.current} onChange={set("current")} className="h-11" />
          </div>
          <div className="space-y-1.5">
            <Label>{t("newPassword")} *</Label>
            <Input data-testid="new-password-input" required type="password" minLength={6} value={form.next} onChange={set("next")} className="h-11" />
          </div>
          <div className="space-y-1.5">
            <Label>{t("confirmPassword")} *</Label>
            <Input data-testid="confirm-password-input" required type="password" minLength={6} value={form.confirm} onChange={set("confirm")} className="h-11" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" className="h-11" onClick={() => onOpenChange(false)}>{t("cancel")}</Button>
            <Button data-testid="change-password-save-button" type="submit" disabled={saving} className="h-11 bg-sky-600 hover:bg-sky-700 text-white">
              {saving ? "..." : t("save")}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
